import { render, staticRenderFns } from "./ShowEmisor.vue?vue&type=template&id=35b0380c&scoped=true"
import script from "./ShowEmisor.vue?vue&type=script&lang=js"
export * from "./ShowEmisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0380c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b0380c')) {
      api.createRecord('35b0380c', component.options)
    } else {
      api.reload('35b0380c', component.options)
    }
    module.hot.accept("./ShowEmisor.vue?vue&type=template&id=35b0380c&scoped=true", function () {
      api.rerender('35b0380c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/emisor/ShowEmisor.vue"
export default component.exports